import { BasePage } from '@/components/ui/base-page'
import { Outlet } from 'react-router-dom'

export function InsightsPage() {
  return (
    <BasePage
      title="Insights"
      description="Industry knowledge, research, and updates from our team"
    >
      <Outlet />
    </BasePage>
  )
}